import { Text } from "@overmap-ai/blocks"
import { type ProcedureInitiative } from "@overmap-ai/common"
import { selectProcedureInitiativeById, selectProcedureTypeById } from "@overmap-ai/core"
import { cx } from "class-variance-authority"
import { memo } from "react"

import { useAppSelector } from "../../store"
import type { BaseIndexLabelProps } from "./typings"
import { computeProcedureInitiativeIndex } from "./utils"

interface ProcedureInitiativeIndexLabelProps extends BaseIndexLabelProps {
	procedureInitiativeId: ProcedureInitiative["uuid"]
}

export const ProcedureInitiativeIndexLabel = memo((props: ProcedureInitiativeIndexLabelProps) => {
	const { className, procedureInitiativeId, ...rest } = props

	const procedureInitiative = useAppSelector(selectProcedureInitiativeById(procedureInitiativeId))

	if (!procedureInitiative) {
		throw new Error(`Could not find procedure initiative ${procedureInitiativeId} in store.`)
	}

	const procedureType = useAppSelector(selectProcedureTypeById(procedureInitiative.procedure_type))!

	return (
		<Text className={cx("text-nowrap", className)} {...rest}>
			{computeProcedureInitiativeIndex(procedureType, procedureInitiative)}
		</Text>
	)
})
ProcedureInitiativeIndexLabel.displayName = "ProcedureInitiativeIndexLabel"
